// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3b9zz","insightsList":"newBusinessInsightsMenu_insightsList__1E_yU","active":"newBusinessInsightsMenu_active__nSoSO"};